import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import GlobalHead from "../../globalComponents/GlobalHead/GlobalHead";
import NotificationData from "./components/NotificationData";
import {
  getNotifications,
  viewedAllNotifications,
} from "../../redux/actions/notificationsActions";
import {
  DATEPICKER_ACTION_TYPE,
  FILTER_ACTION_TYPE,
  NOTIFICATION_ACTION_TYPE,
} from "../../redux/actions-type";

const NotificationPage = () => {
  const dispatch = useDispatch();
  const { notifications, loading } = useSelector(
    (state) => state.notifications
  );
  const { startDate, endDate } = useSelector((state) => state.datepicker);
  const { category } = useSelector((state) => state.filter);

  const filterNotifications = () => {
    dispatch({ type: NOTIFICATION_ACTION_TYPE.RESET_NOTIFICATIONS });

    dispatch(getNotifications(0, startDate, endDate, category));
  };

  const getNextNotifications = () => {
    if (loading) return;

    dispatch(
      getNotifications(notifications?.length || 0, startDate, endDate, category)
    );
  };

  useEffect(() => {
    dispatch(getNotifications(startDate, endDate, category));
  }, []);

  useEffect(() => {
    const isExistUnviewedNotification = notifications?.find(
      (notification) => notification.isView === false
    );

    if (isExistUnviewedNotification) {
      dispatch(viewedAllNotifications());
    }
  }, [notifications]);

  useEffect(() => {
    return () => {
      dispatch({ type: NOTIFICATION_ACTION_TYPE.RESET_NOTIFICATIONS });
      dispatch({ type: DATEPICKER_ACTION_TYPE.RESET });
      dispatch({
        type: FILTER_ACTION_TYPE.GET_FILTER_DATA,
        payload: { category: "" },
      });
    };
  }, []);

  return (
    <div className="details-page courses ">
      <GlobalHead
        searchData={""}
        filter={filterNotifications}
        openModal={false}
        DATA_SEARCH_VALUE={""}
        dataSearchValues={""}
        profile="notifications"
        statusType={"notification"}
        count={0}
      />

      <NotificationData getNextNotifications={getNextNotifications} />
    </div>
  );
};

export default NotificationPage;
